import { render, staticRenderFns } from "./ImpersonateBar.vue?vue&type=template&id=b4a852ee&scoped=true&"
import script from "./ImpersonateBar.vue?vue&type=script&lang=js&"
export * from "./ImpersonateBar.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonateBar.vue?vue&type=style&index=0&id=b4a852ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a852ee",
  null
  
)

export default component.exports